<template>
  <h4>Finance Metrics Page</h4>
</template>

<script>
export default {
  name: "FinanceMetrics",
};
</script>

<style>
</style>